/**
 * Mobile category kicker on the single-live-blog template.
 *
 * Self-gates on `.Article__PortraitHeadContent.--youtube-embed` (unique to
 * single-live-blog, present only when the post has a YouTube embed). Under
 * $bp-md (768px) the head stacks video-first, so the "● Live Blog" kicker —
 * normally a vertical, absolutely-positioned label above .Article__Constraint
 * — is popped off and prepended to the head content, above the headline.
 * styles/site/live-blog-category-kicker.scss restyles it to horizontal flow
 * in the moved position. Crossing back over the breakpoint restores the
 * original DOM position (template order).
 */

const MQ_MOBILE = "(max-width: 768px)"; // $bp-md — where the youtube-embed head goes video-first

function initCategoryKicker() {
	const head = document.querySelector(".Article__PortraitHeadContent.--midterms-2026");
	if (!head) return;

	const article = head.closest("article.Article");
	const kicker = article?.querySelector(":scope > .Article__Category");
	if (!article || !kicker) return;

	// Original position, remembered for restore (template: first child of the article).
	const home = kicker.parentElement;
	const homeNext = kicker.nextElementSibling;

	const place = () => {
		console.log('place called');
		if (window.matchMedia(MQ_MOBILE).matches) {
			console.log('mobile view');
			if (kicker.parentElement !== head) {
				console.log('moving kicker to head');
				head.prepend(kicker);
			}
		} else if (kicker.parentElement !== home) {
			console.log('restoring kicker to original position');
			home.insertBefore(kicker, homeNext);
		}
	};

	const mq = window.matchMedia(MQ_MOBILE);
	place();
	mq.addEventListener("change", place);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initCategoryKicker);
} else {
	initCategoryKicker();
}
